module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "text-center": "",
      "d-flex": "",
      "align-center": ""
    }
  }, [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir o membro da equipe?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirMembroEquipe()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n        *Compete aos Departamentos Acadêmicos destinar carga horária às atividades de pesquisa de seus docentes (Res. 21/2013 - CEPE).\n      ")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaParticipantes,
      "search": _vm.search,
      "no-data-text": 'Nenhum participante cadastrado.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('div', [(_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "edit",
            "color": "primary",
            "tooltip": "Editar membro da equipe",
            "disabled": props.item.situacao === 'I',
            "disabled-tooltip": "A participação do membro da equipe já foi finalizada"
          },
          on: {
            "click": function($event) {
              return _vm.toEditarParticipanteProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "transfer_within_a_station",
            "color": "primary",
            "tooltip": "Finalizar participação do membro da equipe",
            "disabled": props.item.situacao === 'I',
            "disabled-tooltip": "A participação do membro da equipe já foi finalizada"
          },
          on: {
            "click": function($event) {
              return _vm.toFinalizarParticipacaoParticipanteProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "delete",
            "color": "primary",
            "tooltip": "Excluir membro da equipe",
            "disabled": props.item.situacao === 'I',
            "disabled-tooltip": "A participação do membro da equipe já foi finalizada"
          },
          on: {
            "click": function($event) {
              return _vm.toExcluirParticipanteProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.cargaHorariaSemanal",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.cargaHorariaSemanal === null || props.item.cargaHorariaSemanal === '' ? '-' : props.item.cargaHorariaSemanal))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaParticipantes.length) + " " + _vm._s(_vm.listaParticipantes.length > 1 ? 'membros da equipe' : 'membro da equipe') + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toPesquisarPessoas()
      }
    }
  }, [_vm._v("Adicionar Membro da Equipe")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3518ab4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/equipe.vue
// module id = 834
// module chunks = 0